function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#1B3647",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M24.343.655a2.005 2.005 0 0 0-1.468-.61H2.08c-.572 0-1.062.203-1.47.61C.205 1.06 0 1.549 0 2.119v15.762c0 .57.204 1.058.61 1.464.408.406.898.61 1.47.61h20.795c.572 0 1.061-.204 1.468-.61.408-.406.611-.894.611-1.464V2.119c0-.57-.203-1.058-.61-1.464zM23.291 17.88c0 .112-.041.21-.124.292a.401.401 0 0 1-.292.122H2.08a.4.4 0 0 1-.293-.123.399.399 0 0 1-.123-.291V10H23.29v7.88zm0-12.859H1.664V2.12c0-.112.04-.21.123-.292a.401.401 0 0 1 .292-.123h20.796a.4.4 0 0 1 .292.123c.083.083.124.18.124.292v2.903z"
}), React.createElement("path", {
  d: "M3.328 14.987h3.328v1.661H3.328zM8.321 14.987h4.992v1.661H8.321z"
}));

var SvgCreditCard = function SvgCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit-card.90251111.svg";
export { ForwardRef as ReactComponent };